import { useApiQuery } from '../useApiQuery';
import { apiGet, operationsClient } from '@/lib/api';
import { timesheetEndpoints } from '@/lib/api/endpoints';
import { timesheetKeys } from '@/lib/queryKeys';
import type { TimesheetDayEntry } from '@/types/timesheet';

/** Raw time entries for a technician on a single day — the grid drill-down. */
export function useTimesheetDayEntries(technicianId: string | undefined, date: string | undefined) {
  return useApiQuery<TimesheetDayEntry[]>({
    queryKey: timesheetKeys.dayEntries(technicianId ?? '', date ?? ''),
    queryFn: () =>
      apiGet<TimesheetDayEntry[]>(operationsClient, timesheetEndpoints.dayEntries(), {
        params: { technicianId, date },
      }),
    enabled: Boolean(technicianId && date),
  });
}
